<template>
  <div class="printers-table__item printers-table__item--disconnected">
    <div class="top-bar">
      <div class="top-bar--left">
        <h4>{{disconnectedPrinter.description}}</h4>
      </div>
      <div class="top-bar--right">
        <div v-if="showTokenForm">
          <a class="token-info" v-b-tooltip.hover :title="$t('printers.disconnected.tokenTooltip')">
            {{$t('printers.disconnected.token')}}
          </a>
          <a v-if="isRobo3D"
             class="how-to-get-token"
             href="https://docs.google.com/document/d/1x8QVa99kRua44fYP9z_mHdbM4MSw3H7GX64mAXATapk/edit"
             target="_blank">
            {{$t('printers.disconnected.howToGet')}}
          </a>
          <b-input class="inp inp--small" v-model="token" type="text"></b-input>
          <b-button variant="-secondary" size="-small" @click="handleConnect">{{$t('printers.disconnected.connect')}}</b-button>
        </div>
        <span v-else-if="isIndustrial" class="industrial" v-html="$t('printers.disconnected.notSupportedText')">
        </span>
        <span v-else-if="isMakerbot5thGen" v-html="$t('printers.disconnected.connectInstruction', {link: 'https://docs.google.com/document/d/1PO1XPZndOOCyMXlnTqVlEgkmZplIPm3t123VpQdu0OE/edit?usp=sharing'})">
        </span>
        <span v-else-if="isIntegratedUltimaker" v-html="$t('printers.disconnected.connectInstruction', {link: '/#/download/u3'})">
        </span>
        <span v-else-if="isImprinta" v-html="$t('printers.disconnected.connectPrinterToInternet')">
        </span>
        <span v-else class="linikLoad" style="" v-html="$t('printers.disconnected.runClient', {downloadLink: '/#/download'})">
        </span>
        <b-dropdown variant="-ternary btn--dots no--arr btn--outline" size="-small" text="⋮" right>
          <b-dropdown-item-button @click="handleDelete">
            <font-awesome-icon icon="trash-alt" fixed-width /> {{$t('printers.disconnected.remove')}}
          </b-dropdown-item-button>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from "vuex";

  export default {
    name: 'disconnected-printer-item',
    props: ['disconnectedPrinter'],
    data() {
      return {
        token: '',
        processing: false
      }
    },
    computed: {
      ...mapGetters(['isPrinterTypeCanRegisteredByToken', 'isPrinterTypeMakerbot5thGen', 'isPrinterTypeIntegratedUltimaker']),

      showTokenForm() {
        return this.isPrinterTypeCanRegisteredByToken(this.disconnectedPrinter.type_id);
      },

      isIndustrial() {
        return this.disconnectedPrinter.virtual === 't';
      },

      isMakerbot5thGen() {
        return this.isPrinterTypeMakerbot5thGen(this.disconnectedPrinter.type_id);
      },

      isIntegratedUltimaker() {
        return this.isPrinterTypeIntegratedUltimaker(this.disconnectedPrinter.type_id);
      },

      isRobo3D() {
        return this.disconnectedPrinter.description.indexOf('Robo3D') === 0;
      },

      isImprinta() {
        return [261, 281, 282, 283, 290, 291, 309, 310, 311, 312, 313, 314]
            .indexOf(+this.disconnectedPrinter.type_id)>-1;
      }
    },
    methods: {
      ...mapActions(['addPrinterByRegistrationCode', 'deleteDisconnectedPrinter']),

      handleConnect() {
        if (this.token.trim()) {
          this.processing = true;
          this.addPrinterByRegistrationCode(this.token).then(({data}) => {
            this.processing = false;
            if (!data.result) {
              this.msgBoxOk(data.message, {title: this.$t('printers.disconnected.regErrorTitle')});
            }
          }).catch(() => {
            this.processing = false;
            this.msgBoxOk(this.$t('printers.disconnected.regError'), {title: this.$t('printers.disconnected.regErrorTitle')});
          });
        }
      },

      handleDelete() {
        this.deleteDisconnectedPrinter(this.disconnectedPrinter.id).then(({data}) => {
          if (!data.result) {
            this.msgBoxOk(data.message, {title: this.$t('printers.disconnected.removeErrorTitle')});
          }
        }).catch(() => {
          this.msgBoxOk(this.$t('printers.disconnected.removeError'), {title: this.$t('printers.disconnected.removeErrorTitle')});
        })
      },

    }
  }
</script>

<style lang="scss">
  .printers-table__item--disconnected {
    .inp {
      top: -1px;
      position: relative;
    }
  }
</style>
